export const inviteAFriendSchema = {
  email: {
    required: 'O e-mail é um campo obrigatório',
    invalid: 'E-mail inválido',
    alreadyFriends: 'Já são amigos',
    requestSent: 'Pedido de amizade já foi enviado'
  }
};
